// Copyright 2026, Imprivata, Inc.  All rights reserved.

import type { TableColumnsType } from 'antd';
import type { useTranslation } from 'react-i18next';
import type { EndpointRow } from './utils/toEndpointRow';

const TRANSLATION_ROOT = 'portal.settings.endpoints';

export function buildColumns(
  t: ReturnType<typeof useTranslation>['t'],
): TableColumnsType<EndpointRow> {
  return [
    {
      title: t(`${TRANSLATION_ROOT}.columns.hostname`),
      dataIndex: 'hostname',
      key: 'hostname',
      width: 320,
      render: (hostname: string) => <span className="endpoints-hostname">{hostname}</span>,
    },
    {
      // Figma stacks agent version (secondary color) over the installation date
      // (primary color) in a single column.
      title: t(`${TRANSLATION_ROOT}.columns.version`),
      key: 'version-installed',
      render: (_: unknown, row: EndpointRow) => (
        <div className="endpoints-version-installed">
          <span className="endpoints-version">{row.version}</span>
          <span className="endpoints-installed-date">{row.installedDate}</span>
        </div>
      ),
    },
  ];
}
